<template>
  <div class="lc">
    <div class="lc-body">
      <div class="lc-y">
        <span
          v-for="(t, i) in ticks"
          :key="'y' + i"
          class="lc-ytick"
          :style="{ bottom: yPct(t) + '%' }"
        >{{ t }}</span>
      </div>
      <div class="lc-canvas">
        <svg
          class="lc-svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <line
            v-for="(t, i) in ticks"
            :key="'g' + i"
            class="lc-grid"
            x1="0"
            x2="100"
            :y1="yGrid(t)"
            :y2="yGrid(t)"
            vector-effect="non-scaling-stroke"
          />
          <polygon
            v-if="coords.length > 1"
            class="lc-area"
            :points="areaPoints"
            :fill="color + '22'"
          />
          <polyline
            v-if="coords.length > 1"
            class="lc-line"
            :points="linePoints"
            :stroke="color"
            fill="none"
            vector-effect="non-scaling-stroke"
            stroke-linejoin="round"
            stroke-linecap="round"
          />
        </svg>
        <span
          v-for="(c, i) in coords"
          :key="'d' + i"
          class="lc-dot"
          :style="{ left: c.x + '%', bottom: c.y + '%', background: color }"
          :title="(data[i] && data[i].full) + ' · ' + (data[i] && data[i].value)"
        ></span>
      </div>
    </div>
    <div class="lc-x">
      <span v-for="(d, i) in data" :key="'x' + i" class="lc-xtick">{{ d.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LineChart",
  props: {
    // [{ label, full, value }]
    data: { type: Array, default: () => [] },
    color: { type: String, default: "#003ca5" },
  },
  computed: {
    max() {
      return Math.max(1, ...this.data.map((d) => d.value));
    },
    coords() {
      const n = this.data.length;
      return this.data.map((d, i) => ({
        x: n > 1 ? (i / (n - 1)) * 100 : 50,
        y: (d.value / this.max) * 100,
      }));
    },
    linePoints() {
      return this.coords.map((c) => `${c.x},${100 - c.y}`).join(" ");
    },
    areaPoints() {
      const pts = this.coords;
      return (
        `0,100 ${pts.map((c) => `${c.x},${100 - c.y}`).join(" ")} ` +
        `${pts[pts.length - 1].x},100`
      );
    },
    ticks() {
      return [...new Set([0, Math.round(this.max / 2), this.max])];
    },
  },
  methods: {
    // Posición HTML (desde abajo, en %).
    yPct(v) {
      return (v / this.max) * 100;
    },
    // Coordenada SVG (desde arriba, en 0..100).
    yGrid(v) {
      return 100 - (v / this.max) * 100;
    },
  },
};
</script>

<style scoped>
.lc {
  width: 100%;
}
.lc-body {
  display: flex;
  gap: 8px;
  height: 180px;
}
.lc-y {
  position: relative;
  width: 28px;
  flex-shrink: 0;
}
.lc-ytick {
  position: absolute;
  right: 0;
  transform: translateY(50%);
  font-size: 10px;
  color: var(--pt-muted);
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
.lc-canvas {
  position: relative;
  flex: 1;
  height: 100%;
  min-width: 0;
}
.lc-svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}
.lc-grid {
  stroke: var(--pt-line);
}
.lc-line {
  stroke-width: 2;
}
.lc-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  transform: translate(-50%, 50%);
  border: 2px solid var(--pt-card);
  pointer-events: none;
}
.lc-x {
  display: flex;
  margin-left: 36px;
  margin-top: 6px;
}
.lc-xtick {
  flex: 1;
  text-align: center;
  font-size: 10px;
  color: var(--pt-muted);
  white-space: nowrap;
}
</style>
